export default function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-900">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-surface-700 border-t-brand-500 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-400">Loading...</p>
      </div>
    </div>
  );
}

